import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import {
  cameraRotateModalProps,
  cameraRotateProps,
} from '@/common/components/camera/components/modals/cameraRotateModal/cameraRotateModal.type';
import React from 'react';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export default ({ open, onClose }: cameraRotateModalProps) => {
  return (
    <MainModal closeModal={onClose} open={open}>
      <CameraDenyPermissionModal onClose={onClose} />
    </MainModal>
  );
};
const CameraDenyPermissionModal: React.FC<cameraRotateProps> = ({
  onClose,
}) => {
  return (
    <>
      <TitleDescription className={css({ mb: '1rem' })}>
        دسترسی به دوربین{' '}
      </TitleDescription>
      <Box display="flex" flexDirection="column" alignItems="center" gap="1rem">
        <Typography color="black-1">
          دسترسی به دوربین از سوی شما مسدود شده است. جهت ادامه فرآیند لازم است
          ضمن مراجعه به تنظیمات برنامه، دسترسی مربوطه را فعال نمایید.
        </Typography>
        <Button onClick={onClose} fullWidth color="primary">
          بازگشت
        </Button>
      </Box>
    </>
  );
};
